import { LinearProgress } from "@mui/material";
import React from "react";

const Tab = ({ nightAuditTabEnum, activeTab, handleTabChange }) => {
  const progress = ((activeTab + 1) / 4) * 100;

  return (
    <div className="flex flex-col gap-[8px] p-5 sticky top-0 z-[50] bg-[#FFF]">
      <div className="flex justify-between items-center">
        {nightAuditTabEnum?.map((Obj, idx) => {
          return (
            <div
              key={Obj}
              className="font-[400] text-[#667085] cursor-poinster text-[14px] leading-[18px]"
              // onClick={() => handleTabChange(idx)}
            >
              {Obj}
            </div>
          );
        })}
      </div>

      <div>
        <LinearProgress
          variant="determinate"
          value={activeTab === 0 ? 15 : progress}
          sx={{
            height: 10,
            borderRadius: 7.5,
            backgroundColor: "#F3F4F6",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#059669", // Progress color
            },
          }}
        />{" "}
      </div>
    </div>
  );
};

export default Tab;
